import { AttachmentDraft } from "@adsk/acc-attachments";
import {
  IssueAttachmentCreationAttributes,
  AttachmentsDomainEntity,
} from "@adsk/acc-issues-types";

export type CustomAttachmentDraft = {
  attachmentId: string;
  storageUrn?: string;
  fileName?: string;
  displayName: string;
  attachmentType: string;
};

export const getCustomDraftAttachment = (
  unlinkedAttachment: AttachmentDraft
) => {
  return {
    attachmentId: unlinkedAttachment.attachmentId,
    displayName: unlinkedAttachment.file.name,
    fileName: unlinkedAttachment.originalFileName,
    attachmentType: "issue-attachment",
    storageUrn: unlinkedAttachment.storageUrn,
  };
};

export const getAttachmentRequestData = (
  issueId: string,
  unlinkedAttachment: AttachmentDraft
) => {
  return {
    isNew: false,
    domainEntityId: issueId,
    attachments: [getCustomDraftAttachment(unlinkedAttachment)],
  } as IssueAttachmentCreationAttributes;
};

export const getIssueWithAttachmentsRequestData = ({
  domainEntity,
  attachments,
}: {
  domainEntity: AttachmentsDomainEntity;
  attachments: CustomAttachmentDraft[];
}): IssueAttachmentCreationAttributes => {
  return {
    isNew: true,
    domainEntity,
    domainEntityId: domainEntity.id,
    attachments,
  } as IssueAttachmentCreationAttributes;
};
